import { render, staticRenderFns } from "./ActionArrowButton.vue?vue&type=template&id=b5d65942&scoped=true"
import script from "./ActionArrowButton.vue?vue&type=script&lang=js"
export * from "./ActionArrowButton.vue?vue&type=script&lang=js"
import style0 from "./ActionArrowButton.vue?vue&type=style&index=0&id=b5d65942&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d65942",
  null
  
)

export default component.exports